module.exports = __webpack_public_path__ + "static/lottery-pointer.93817131.png";